import ApiHandler from '@/api/base'
import { handleError } from '@/utils/error-handling'

import { transformWebhookName } from '@/views/workspaces/settings/integrations/integration-utils'

const transformAttributeValue = attributeValue => {
  try {
    const parsed = JSON.parse(attributeValue)

    const channelName = parsed.name || ''

    return {
      ...parsed,
      name: transformWebhookName(channelName)
    }
  } catch (error) {
    handleError({ error })
    return {}
  }
}

class IntegrationApiHandler extends ApiHandler {
  async getChannelsAttributes({ attributeTypeId, channelTypeId }) {
    const { data } = await this.http.get('/notification/channels/attributes', {
      params: {
        attributeTypeId,
        channelTypeId
      }
    })
    return data.map(item => {
      return {
        ...item,
        attributeValue: transformAttributeValue(item.attributeValue)
      }
    })
  }

  async createChannelsAttributes({ channelTypeId, attributeTypeId, attributeValue }) {
    const { data } = await this.http.post('/notification/channels/attributes', {
      channelTypeId,
      attributeTypeId,
      attributeValue: JSON.stringify(attributeValue)
    })

    return data
  }

  async getChannelsAttributesById({ id }) {
    const { data } = await this.http.get(`/notification/channels/attributes/${id}`)

    return data
  }

  async deleteChannelsAttributesById({ id }) {
    const { data } = await this.http.delete(`/notification/channels/attributes/${id}`)

    return data
  }
}

export default IntegrationApiHandler
